<template>
  <div class="general-box">
    <div class="stats-info-block">
      <div class="stat-info-percentage">
      {{ $t('stats_summary.guests')}} <span :class="getColorClass('guests_count')">
          {{ getComparisonText('guests_count') }}
        </span>
      </div>
      <div class="number">{{summary.guests_count}}</div>
    </div>
    <div class="stats-info-block">
      <div class="stat-info-percentage">
        {{ $t('stats_summary.orders')}} <span :class="getColorClass('orders_count')">
          {{ getComparisonText('orders_count') }}
        </span>
      </div>
      <div class="number">{{ summary.orders_count }}</div>
    </div>
    <div class="stats-info-block">
      <div class="stat-info-percentage">
        {{ $t('stats_summary.average')}} <span :class="getColorClass('orders_average')">
          {{ getComparisonText('orders_average') }}
        </span>
      </div>
      <div class="number">{{ formatNumber(summary.orders_average) }} <span>{{ currency.iso_code }}</span></div>
    </div>
    <div class="stats-info-block">
      <div class="stat-info-percentage">
        {{ $t('stats_summary.income')}} <span :class="getColorClass('orders_total')">
          {{ getComparisonText('orders_total') }}
        </span>
      </div>
      <div class="number">{{ formatNumber(summary.orders_total) }} <span>{{ currency.iso_code }}</span></div>
    </div>

    <!-- <div class="stats-info">
      <h4>
        <img src="/icons/white-circle.png" alt /> {{ $t("stats.averange") }}
      </h4>
      <h3>
        {{ values.average }}
        <span>{{ currency.iso_code }}</span>
      </h3>
      <p>
        <small :class="getColorClass(comparison.average)">
          {{ comparison.average | appendSign }}%
        </small>
        {{ $t("stats.since") }}
      </p>
    </div>
    <div class="stats-info">
      <h4>
        <img src="/icons/white-circle.png" alt /> {{ $t("stats.income_month") }}
      </h4>
      <h3>
        {{ values.income }}
        <span>{{ currency.iso_code }}</span>
      </h3>
      <p>
        <small :class="getColorClass(comparison.income)"
          >{{ comparison.income | appendSign }}%</small
        >
        {{ $t("stats.since") }}
      </p>
    </div>
    <div class="stats-info">
      <h4>
        <img src="/icons/white-circle.png" alt /> {{ $t("stats.orders_month") }}
      </h4>
      <h3>{{ values.orders }}</h3>
      <p>
        <small :class="getColorClass(comparison.orders)"
          >{{ comparison.orders | appendSign }}%</small
        >
        {{ $t("stats.since") }}
      </p>
    </div>
    <div class="stats-info">
      <h4><img src="/icons/white-circle.png" alt /> Bounce rate</h4>
      <h3>{{ values.bounce }}%</h3>
      <p>
        <small :class="getColorClass(-comparison.bounce)"
          >{{ comparison.bounce | appendSign }}%</small
        >
        {{ $t("stats.since") }}
      </p>
    </div> -->
  </div>
</template>

<script>
function percentChange(old_value, new_value) {
  if (old_value <= 0.0001) return 0;

  const diff = new_value - old_value;

  return Math.round((diff / Math.abs(old_value)) * 100);
}

export default {
  props: {
    values: Object,
    previous: Object,
    summary: Object
  },
  methods: {
    getColorClass(key) {
      const value = this.comparison[key];
      return value >= 0 ? "green" : "red";
    },
    getComparisonText(key) {
      const n = this.comparison[key];

      if (n == 0) return '';

      if (n > 0) {
        return `+${n}%`;
      } else {
        return `${n}%`;
      }
    },
    formatNumber(raw) {
      if (!raw || isNaN(raw)) return 0;

      return (+raw).toFixed(2); 
    }
  },
  computed: {
    comparison() {
      return {
        guests_count: percentChange(this.previous.guests_count, this.summary.guests_count),
        orders_count: percentChange(this.previous.orders_count, this.summary.orders_count),
        orders_average: percentChange(this.previous.orders_average, this.summary.orders_average),
        orders_total: percentChange(this.previous.orders_total, this.summary.orders_total)
      };
    },
    currency() {
      return this.$store.state.currency;
    },
  },
  filters: {
    appendSign(v) {
      return v >= 0 ? `+${v}` : `${v}`;
    },
  },
};
</script>

<style scoped>
.general-box {
  background: #1d1d1b;
  padding: 2.222vh 3.333vh;
  width: 100%;
  border-radius: 1.333vh;
  color: #ededed;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.stats-info-block {
  width: 26.5%;
  border-right: 0.11vh solid #908f8d;
  padding: 0 3.333vh;
}
.stats-info-block:first-child {
  padding-left: 0;
  width: 23.5%;
}
.stats-info-block:last-child {
  padding-right: 0;
  width: 23.5%;
  border: none;
}
.stat-info-percentage {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #ededed;
  display: flex;
  justify-content: space-between;
}
span.red {
  color: #e2223b;
}
span.green {
  color: #11d180;
}
.number {
  margin-top: 0.5555555555555556vh;
  font-size: 5.555555555555555vh;
  line-height: 6.444444444444445vh;
  color: #ededed;
}
.number span {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;

  color: #ededed;
}
</style>
